// frontend/src/config/procurementFields.ts

export interface SystemField {
    key: string;
    label: string;
    required: boolean;
    description?: string;
}

export const PROCUREMENT_FIELDS: SystemField[] = [
    { key: 'sku', label: 'Código Material (SKU)', required: true, description: 'Identificador único del artículo (ej: STP-MP-0031)' },
    { key: 'purchase_date', label: 'Fecha Compra', required: true, description: 'Fecha de albarán o factura' },
    { key: 'quantity', label: 'Cantidad', required: true, description: 'Volumen comprado (Kg, Ton, Ud)' },
    { key: 'unit_price', label: 'Precio Unitario', required: true, description: 'Precio neto por unidad' },
    { key: 'provider_id', label: 'Código Proveedor', required: true, description: 'ID ERP (ej: 2045) para agrupar negociaciones' },
    { key: 'provider_name', label: 'Nombre Proveedor', required: false, description: 'Razón social (ej: ACEROS S.A.)' },
    { key: 'currency', label: 'Moneda', required: false, description: 'ISO Code (EUR). Default: EUR' },
];